import { FC } from "react";
import styled from "styled-components";
import { NavBarProps } from "../../../types";
import Flex from "@/shared/globals/UiElements/Flex";
import { Section } from "@/shared/layout";
import BurgerMenu from "./BurgerMenu";
import SearchOverlay from "./SearchBar/SearchOverlay";
import { BurgerIcon2 } from "@/assets/Icons/BurgerIcon2";
import { useParams, usePurePathname } from "@/i18n/i18n-navigation";
import Logo from "../../elements/Logo";
import FixedNav from "../../elements/FixedNav";

const MobileNavbar: FC<NavBarProps> = ({ menu, socialMedia }) => {
  const pathname = usePurePathname();
  const params = useParams();
  const isProductPage = pathname.startsWith("/product") && params.product;
  return (
    <ShowBelowMobile>
      <Section boxShadow background="white">
        <StyledFlex alignItems="center" justifyContent="space-between">
          <BurgerMenu
            menus={menu!}
            socialSettings={socialMedia!}
            icon={<BurgerIcon2 />}
          />
          <Logo />
          <SearchOverlay />
        </StyledFlex>
      </Section>
      {!isProductPage && (
        <FixedNav menus={menu!} socialSettings={socialMedia!} />
      )}
    </ShowBelowMobile>
  );
};

export default MobileNavbar;

/**
 *
 * Styles
 *
 */

const ShowBelowMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const StyledFlex = styled(Flex)`
  padding-block: 10px;
`;
